import {
  hasNextChapter,
  hasNextQuestions,
  hasPreviousChapter,
  hasPreviousQuestions,
  selectNbPreviousQuestionPages,
  selectNbQuestionPages,
  selectNumberOfQuestionsForChapter,
  selectQuestions,
} from 'affiny-core/redux/selectors/reflistsSelectors';
import { connect } from 'react-redux';
import { EReflistChapterName } from '../../api/repositories/reflists/reflists.types';
import { IRootState } from '../../state';

interface IOwnProps {
  chapterLabel: EReflistChapterName;
  questionIndex: number;
}

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  return {
    ancestorPageQuestions: selectQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex - 2
    ),
    previousPageQuestions: selectQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex - 1
    ),
    currentPageQuestions: selectQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
    nextPageQuestions: selectQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex + 1
    ),
    hasNextQuestions: hasNextQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
    hasPreviousQuestions: hasPreviousQuestions(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
    hasNextChapter: hasNextChapter(state, ownProps.chapterLabel),
    hasPreviousChapter: hasPreviousChapter(state, ownProps.chapterLabel),
    numberOfQuestionsForChapter: (chapterLabel: EReflistChapterName) =>
      selectNumberOfQuestionsForChapter(state, chapterLabel),
    nbQuestionPages: selectNbQuestionPages(state),
    nbPreviousQuestionPages: selectNbPreviousQuestionPages(
      state,
      ownProps.chapterLabel,
      ownProps.questionIndex
    ),
  };
};

export type IQuestionContainerProps = ReturnType<typeof mapStateToProps>;

export const questionContainerFactory = connect(mapStateToProps);
